export enum SuperRosterView {
  SEARCH = 1,
  EDIT = 2,
}
